var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Http, RequestOptions, Headers } from '@angular/http';
import { Router } from '@angular/router';
import { I18nService } from '@app/core';
import { UtilService } from './util.service';
import { environment } from 'environments/environment';
import { CryptographyService } from '@app/cryptography.service';
var ConfigType;
(function (ConfigType) {
    ConfigType[ConfigType["ApiUrl"] = 1] = "ApiUrl";
    ConfigType[ConfigType["CustomApiUrl"] = 2] = "CustomApiUrl";
    ConfigType[ConfigType["LogInUrl"] = 3] = "LogInUrl";
    ConfigType[ConfigType["PortalApiUrl"] = 4] = "PortalApiUrl";
    ConfigType[ConfigType["PortalLoginUrl"] = 5] = "PortalLoginUrl";
})(ConfigType || (ConfigType = {}));
var ApiService = /** @class */ (function () {
    function ApiService(http, route, i18nService, util, crypto) {
        this.http = http;
        this.route = route;
        this.i18nService = i18nService;
        this.util = util;
        this.crypto = crypto;
    }
    ApiService.prototype.get = function (system, action, queryParam) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var pbk, aesKey, aesPublic, reqObj, url;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.keyFromCk()];
                    case 1:
                        pbk = _a.sent();
                        aesKey = this.crypto.genAesKey();
                        aesPublic = this.crypto.rsaEncrypt(pbk, aesKey);
                        reqObj = {
                            m: this.crypto.encrypt("GET", aesKey),
                            route: this.crypto.encrypt("/" + system + "/" + action + (queryParam == null ? "" : "?" + queryParam), aesKey),
                            s: aesPublic
                        };
                        url = "";
                        if (environment.apiurl != "") {
                            if (environment.apiPort == "") {
                                url = environment.apiurl + environment.apiPath;
                            }
                            else {
                                url = environment.apiurl + ":" + environment.apiPort + environment.apiPath;
                            }
                        }
                        else {
                            if (environment.apiPort == "") {
                                url = this.util.baseUrl() + environment.apiPath;
                            }
                            else {
                                url = this.util.baseUrlNoPort() + ":" + environment.apiPort + environment.apiPath;
                            }
                        }
                        //let url = this.util.baseUrlNoPort() + (environment.apiPort == "" ? "" : ":" +environment.apiPort) "/api/Core/PostApi"
                        url += "/api/Core/PostApi";
                        //url = "https://dpaapi.msccrm.com:443/customApi/api/Core/PostApi"
                        return [2 /*return*/, new Promise(function (resolve) {
                                _this.http.post(url, reqObj).toPromise().then(function (data) { return __awaiter(_this, void 0, void 0, function () {
                                    var res;
                                    return __generator(this, function (_a) {
                                        if (data["_body"] != null && data["_body"] != "") {
                                            res = data.json();
                                            res = this.crypto.decryptDictValue(res, aesKey);
                                            resolve(res);
                                        }
                                        else {
                                            resolve(data);
                                        }
                                        return [2 /*return*/];
                                    });
                                }); }).catch(function (err) {
                                    if (err["_body"] != null && err["_body"] != "") {
                                        var tmp = _this.crypto.decryptDictValue(JSON.parse(err["_body"]), aesKey);
                                        resolve(tmp);
                                    }
                                    else {
                                        resolve(err);
                                    }
                                });
                            })];
                }
            });
        });
    };
    ApiService.prototype.getMasterAddress = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var url;
            return __generator(this, function (_a) {
                url = "";
                if (environment.apiurl != "") {
                    if (environment.apiPort == "") {
                        url = environment.apiurl + environment.apiPath;
                    }
                    else {
                        url = environment.apiurl + ":" + environment.apiPort + environment.apiPath;
                    }
                }
                else {
                    if (environment.apiPort == "") {
                        url = this.util.baseUrl() + environment.apiPath;
                    }
                    else {
                        url = this.util.baseUrlNoPort() + ":" + environment.apiPort + environment.apiPath;
                    }
                }
                //let url = this.util.baseUrlNoPort() + (environment.apiPort == "" ? "" : ":" + environment.apiPort)
                url += "/api/master/address";
                //url = "https://dpaapi.msccrm.com:443/customApi/api/master/address"
                return [2 /*return*/, new Promise(function (resolve) {
                        _this.http.get(url).toPromise().then(function (data) {
                            var res = data.json();
                            resolve(res);
                        }).catch(function (err) {
                            _this.util.ShowWaiting(false);
                            console.error("get address failed.");
                        });
                    })];
            });
        });
    };
    ApiService.prototype.getCustomAPI = function (system, action, queryParam) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var pbk, aesKey, aesPublic, reqObj, url;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.keyFromCk()];
                    case 1:
                        pbk = _a.sent();
                        aesKey = this.crypto.genAesKey();
                        aesPublic = this.crypto.rsaEncrypt(pbk, aesKey);
                        reqObj = {
                            route: this.crypto.encrypt("/api/" + system + "/" + action + (queryParam == null ? "" : "?" + queryParam), aesKey),
                            s: aesPublic
                        };
                        url = "";
                        if (environment.apiurl != "") {
                            if (environment.apiPort == "") {
                                url = environment.apiurl + environment.apiPath;
                            }
                            else {
                                url = environment.apiurl + ":" + environment.apiPort + environment.apiPath;
                            }
                        }
                        else {
                            if (environment.apiPort == "") {
                                url = this.util.baseUrl() + environment.apiPath;
                            }
                            else {
                                url = this.util.baseUrlNoPort() + ":" + environment.apiPort + environment.apiPath;
                            }
                        }
                        //let url = this.util.baseUrlNoPort() + (environment.apiPort == "" ? "" : ":" + environment.apiPort)
                        url += "/api/" + system + "/" + action; //+ param
                        //url = "https://dpaapi.msccrm.com:443/customApi/api/" + system + "/" + action
                        return [2 /*return*/, new Promise(function (resolve) {
                                _this.http.post(url, reqObj).toPromise().then(function (data) { return __awaiter(_this, void 0, void 0, function () {
                                    var res;
                                    return __generator(this, function (_a) {
                                        if (data["_body"] != null && data["_body"] != "") {
                                            res = data.json();
                                            res = this.crypto.decryptDictValue(res, aesKey);
                                            resolve(res);
                                        }
                                        else {
                                            resolve(data);
                                        }
                                        return [2 /*return*/];
                                    });
                                }); }).catch(function (err) {
                                    if (err["_body"] != null && err["_body"] != "") {
                                        var tmp = _this.crypto.decryptDictValue(JSON.parse(err["_body"]), aesKey);
                                        resolve(tmp);
                                    }
                                    else {
                                        resolve(err);
                                    }
                                });
                            })];
                }
            });
        });
    };
    ApiService.prototype.post = function (system, action, dataObj, mode, branchID) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var pbk, aesKey, aesPublic, reqObj2, url;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        dataObj["dpa_callby"] = '2';
                        return [4 /*yield*/, this.keyFromCk()];
                    case 1:
                        pbk = _a.sent();
                        aesKey = this.crypto.genAesKey();
                        aesPublic = this.crypto.rsaEncrypt(pbk, aesKey);
                        reqObj2 = {
                            m: this.crypto.encrypt("POST", aesKey),
                            route: this.crypto.encrypt("/" + system + "/" + action, aesKey),
                            s: aesPublic,
                            req: this.crypto.encrypt(JSON.stringify(dataObj), aesKey)
                        };
                        url = "";
                        if (environment.apiurl != "") {
                            if (environment.apiPort == "") {
                                url = environment.apiurl + environment.apiPath;
                            }
                            else {
                                url = environment.apiurl + ":" + environment.apiPort + environment.apiPath;
                            }
                        }
                        else {
                            if (environment.apiPort == "") {
                                url = this.util.baseUrl() + environment.apiPath;
                            }
                            else {
                                url = this.util.baseUrlNoPort() + ":" + environment.apiPort + environment.apiPath;
                            }
                        }
                        //let url = this.util.baseUrlNoPort() + (environment.apiPort == "" ? "" : ":" +environment.apiPort)
                        url += "/api/Core/PostApi";
                        //url = "https://dpaapi.msccrm.com:443/customApi/api/Core/PostApi"
                        return [2 /*return*/, new Promise(function (resolve) {
                                _this.http.post(url, reqObj2).toPromise().then(function (data) {
                                    if (data["_body"] != null && data["_body"] != "") {
                                        var res = data.json();
                                        res = _this.crypto.decryptDictValue(res, aesKey);
                                        resolve(res);
                                    }
                                    else {
                                        resolve(data);
                                    }
                                }).catch(function (err) {
                                    if (err["_body"] != null && err["_body"] != "") {
                                        var tmp = _this.crypto.decryptDictValue(JSON.parse(err["_body"]), aesKey);
                                        resolve(tmp);
                                    }
                                    else {
                                        resolve(err);
                                    }
                                });
                            })];
                }
            });
        });
    };
    ApiService.prototype.postCustomApi = function (system, action, dataObj) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var url, pbk, aesKey, aesPublic, reqObj;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = "";
                        if (environment.apiurl != "") {
                            if (environment.apiPort == "") {
                                url = environment.apiurl + environment.apiPath;
                            }
                            else {
                                url = environment.apiurl + ":" + environment.apiPort + environment.apiPath;
                            }
                        }
                        else {
                            if (environment.apiPort == "") {
                                url = this.util.baseUrl() + environment.apiPath;
                            }
                            else {
                                url = this.util.baseUrlNoPort() + ":" + environment.apiPort + environment.apiPath;
                            }
                        }
                        //let url = this.util.baseUrlNoPort() + (environment.apiPort == "" ? "" : ":" +environment.apiPort)
                        url += "/api/" + system + "/" + action;
                        return [4 /*yield*/, this.keyFromCk()];
                    case 1:
                        pbk = _a.sent();
                        aesKey = this.crypto.genAesKey();
                        aesPublic = this.crypto.rsaEncrypt(pbk, aesKey);
                        reqObj = __assign({}, dataObj);
                        reqObj = this.crypto.encryptDictValue(reqObj, aesKey);
                        reqObj["s"] = aesPublic;
                        return [2 /*return*/, new Promise(function (resolve) {
                                _this.http.post(url, reqObj).toPromise().then(function (data) {
                                    if (data["_body"] != null && data["_body"] != "") {
                                        var res = data.json();
                                        res = _this.crypto.decryptDictValue(res, aesKey);
                                        resolve(res);
                                    }
                                    else {
                                        resolve(data);
                                    }
                                }).catch(function (err) {
                                    if (err["_body"] != null && err["_body"] != "") {
                                        var tmp = _this.crypto.decryptDictValue(JSON.parse(err["_body"]), aesKey);
                                        resolve(tmp);
                                    }
                                    else {
                                        resolve(err);
                                    }
                                });
                            })];
                }
            });
        });
    };
    ApiService.prototype.checkCard = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var url;
            return __generator(this, function (_a) {
                url = "";
                if (environment.apiPort == "") {
                    url = this.util.baseUrl() + environment.apiPath;
                }
                else {
                    url = this.util.baseUrlNoPort() + ":" + environment.apiPort + environment.apiPath;
                }
                //let url = this.util.baseUrlNoPort() + (environment.apiPort == "" ? "" : ":" +environment.apiPort)
                url += "/api/Dopa/CheckCard";
                //url = "https://dpaapi.msccrm.com:443/customApi/api/Dopa/CheckCard"
                return [2 /*return*/, new Promise(function (resolve) {
                        _this.http.post(url, req).toPromise().then(function (data) {
                            if (data["_body"] != null && data["_body"] != "") {
                                var res = data.json();
                                resolve(res);
                            }
                            else {
                                resolve(data);
                            }
                        }).catch(function (err) {
                            if (err["_body"] != null && err["_body"] != "") {
                                var res = err.json();
                                resolve(res);
                            }
                            else {
                                resolve(err);
                            }
                        });
                    })];
            });
        });
    };
    ApiService.prototype.put = function (system, action, dataObj, mode, branchID) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var pbk, aesKey, aesPublic, reqObj2, url;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        dataObj["dpa_callby"] = '2';
                        return [4 /*yield*/, this.keyFromCk()];
                    case 1:
                        pbk = _a.sent();
                        aesKey = this.crypto.genAesKey();
                        aesPublic = this.crypto.rsaEncrypt(pbk, aesKey);
                        reqObj2 = {
                            m: this.crypto.encrypt("PUT", aesKey),
                            route: this.crypto.encrypt("/" + system + "/" + action, aesKey),
                            s: aesPublic,
                            req: this.crypto.encrypt(JSON.stringify(dataObj), aesKey)
                        };
                        url = "";
                        if (environment.apiurl != "") {
                            if (environment.apiPort == "") {
                                url = environment.apiurl + environment.apiPath;
                            }
                            else {
                                url = environment.apiurl + ":" + environment.apiPort + environment.apiPath;
                            }
                        }
                        else {
                            if (environment.apiPort == "") {
                                url = this.util.baseUrl() + environment.apiPath;
                            }
                            else {
                                url = this.util.baseUrlNoPort() + ":" + environment.apiPort + environment.apiPath;
                            }
                        }
                        //let url = this.util.baseUrlNoPort() + (environment.apiPort == "" ? "" : ":" +environment.apiPort)
                        url += "/api/Core/PostApi";
                        //url = "https://dpaapi.msccrm.com:443/customApi/api/Core/PostApi"
                        return [2 /*return*/, new Promise(function (resolve) {
                                _this.http.post(url, reqObj2).toPromise().then(function (data) {
                                    // resolve(data);
                                    if (data["_body"] != null && data["_body"] != "") {
                                        var res = data.json();
                                        res = _this.crypto.decryptDictValue(res, aesKey);
                                        resolve(res);
                                    }
                                    else {
                                        resolve(data);
                                    }
                                }).catch(function (err) {
                                    if (err["_body"] != null && err["_body"] != "") {
                                        var tmp = _this.crypto.decryptDictValue(JSON.parse(err["_body"]), aesKey);
                                        resolve(tmp);
                                    }
                                    else {
                                        resolve(err);
                                    }
                                });
                            })];
                }
            });
        });
    };
    ApiService.prototype.postOther = function (url, datapost, contentType) {
        return __awaiter(this, void 0, void 0, function () {
            var requestHeaders, urlencoded, authHeader, requestOptions;
            return __generator(this, function (_a) {
                requestHeaders = { 'Content-Type': 'application/x-www-form-urlencoded' };
                urlencoded = new URLSearchParams();
                urlencoded.append("grant_type", "authorization_code");
                urlencoded.append("code", datapost["code"]);
                urlencoded.append("redirect_uri", this.util.baseUrl() + "/mainmenu/login");
                urlencoded.append("client_id", "1654952386");
                urlencoded.append("client_secret", "d129b1c240d16dde27204dadbc5f612c");
                authHeader = new Headers();
                authHeader.append('Authorization', "Bearer");
                requestOptions = {
                    method: 'POST',
                    body: urlencoded,
                    redirect: 'follow',
                    headers: requestHeaders
                };
                return [2 /*return*/, fetch("https://api.line.me/oauth2/v2.1/token", requestOptions)
                        .then(function (response) {
                        return response.json();
                    })
                        .then(function (result) {
                        return result;
                    })
                        .catch(function (error) {
                        return console.log('error', error);
                    })];
            });
        });
    };
    ApiService.prototype.delete = function (system, action) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var _a, url, header, options;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!(this.API_URL == undefined || this.API_URL == null)) return [3 /*break*/, 2];
                        _a = this;
                        return [4 /*yield*/, this.getConfig()];
                    case 1:
                        _a.API_URL = _b.sent();
                        _b.label = 2;
                    case 2:
                        if (this.ipClient == undefined || this.ipClient == null) {
                            this.ipClient = sessionStorage.getItem("clientIP");
                        }
                        url = this.API_URL + '/' + system + '/' + action;
                        header = new Headers({ 'Content-Type': 'application/json' });
                        options = new RequestOptions({ headers: header });
                        return [2 /*return*/, new Promise(function (resolve) {
                                _this.http.delete(url, options).toPromise().then(function (data) { return __awaiter(_this, void 0, void 0, function () {
                                    var res;
                                    return __generator(this, function (_a) {
                                        if (data["_body"] != null && data["_body"] != "") {
                                            res = data.json();
                                            res = this.crypto.decryptDictValue(res);
                                            resolve(res);
                                        }
                                        else {
                                            resolve(data);
                                        }
                                        return [2 /*return*/];
                                    });
                                }); }).catch(function (err) {
                                    if (err["_body"] != null && err["_body"] != "") {
                                        var tmp = _this.crypto.decryptDictValue(JSON.parse(err["_body"]));
                                        resolve(tmp);
                                    }
                                    else {
                                        resolve(err);
                                    }
                                });
                            })];
                }
            });
        });
    };
    ApiService.prototype.getConfig = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var configData;
            return __generator(this, function (_a) {
                configData = '';
                return [2 /*return*/, new Promise(function (resolve) {
                        _this.http.get('./assets/env.json').toPromise().then(function (data) {
                            var res = data.json();
                            resolve(_this.crypto.decrypt(res.apiUrl));
                        }).catch(function (err) {
                            _this.util.ShowWaiting(false);
                            // localStorage.setItem('errorMesaage', 'เกิดข้อผิดพลาดบางประการ');
                            // this.route.navigate(['/error']);
                        });
                    })];
            });
        });
    };
    ApiService.prototype.getConfigByKey = function (key) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var configData;
            return __generator(this, function (_a) {
                configData = '';
                return [2 /*return*/, new Promise(function (resolve) {
                        _this.http.get('./assets/env.json').toPromise().then(function (data) {
                            var res = data.json();
                            resolve(_this.crypto.decrypt(res.customApiUrl));
                        }).catch(function (err) {
                            _this.util.ShowWaiting(false);
                            // localStorage.setItem('errorMesaage', 'เกิดข้อผิดพลาดบางประการ');
                            // this.route.navigate(['/error']);
                        });
                    })];
            });
        });
    };
    ApiService.prototype.getNotiApiUrl = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var configData;
            return __generator(this, function (_a) {
                configData = '';
                return [2 /*return*/, new Promise(function (resolve) {
                        _this.http.get('./assets/env.json').toPromise().then(function (data) {
                            var res = data.json();
                            resolve(res.notiApiUrl);
                        }).catch(function (err) {
                            _this.util.ShowWaiting(false);
                            // localStorage.setItem('errorMesaage', 'เกิดข้อผิดพลาดบางประการ');
                            // this.route.navigate(['/error']);
                        });
                    })];
            });
        });
    };
    ApiService.prototype.postnotauthen = function (system, action, dataObj, mode, branchID) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var _a, url, header, options, datapost;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!(this.API_URL == undefined || this.API_URL == null)) return [3 /*break*/, 2];
                        _a = this;
                        return [4 /*yield*/, this.getConfig()];
                    case 1:
                        _a.API_URL = _b.sent();
                        _b.label = 2;
                    case 2:
                        if (this.ipClient == undefined || this.ipClient == null) {
                            this.ipClient = localStorage.getItem("clientIP");
                        }
                        url = this.API_URL + '/' + system + '/' + action;
                        header = new Headers({ 'Content-Type': 'application/json' });
                        options = new RequestOptions({ headers: header });
                        datapost = {};
                        datapost["user"] = this.util.GetUserID();
                        datapost["ip"] = this.util.GetClientIP();
                        datapost["lang"] = this.i18nService.language;
                        datapost["requestData"] = dataObj;
                        datapost["mode"] = mode;
                        datapost["branch_id"] = branchID;
                        //  dataObj = Object.assign(datahead, dataObj);
                        return [2 /*return*/, new Promise(function (resolve) {
                                _this.http.post(url, datapost, options).toPromise().then(function (data) {
                                    var res = data.json();
                                    resolve(res);
                                }).catch(function (err) {
                                    _this.util.ShowWaiting(false);
                                    resolve(null);
                                    //this.util.ErrorDialog('System Error : ' + err);
                                });
                            })];
                }
            });
        });
    };
    ApiService.prototype.getConfigLogin = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var configData;
            return __generator(this, function (_a) {
                configData = '';
                return [2 /*return*/, new Promise(function (resolve) {
                        _this.http.get('./assets/env.json').toPromise().then(function (data) {
                            var res = data.json();
                            resolve(res.UrlLogin);
                        }).catch(function (err) {
                            _this.util.ShowWaiting(false);
                            // localStorage.setItem('errorMesaage', 'เกิดข้อผิดพลาดบางประการ');
                            // this.route.navigate(['/error']);
                        });
                    })];
            });
        });
    };
    ApiService.prototype.getTokenConfig = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve) {
                        _this.http.get('./assets/env.json').toPromise().then(function (data) {
                            var res = data.json();
                            resolve(res);
                        }).catch(function (err) {
                            return null;
                        });
                    })];
            });
        });
    };
    ApiService.prototype.getToken = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var config, url, req, header, options;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getTokenConfig()];
                    case 1:
                        config = _a.sent();
                        url = this.crypto.decrypt(config.getTokenUrl);
                        req = {
                            "username": config.getTokenUser,
                            "password": config.getTokenPassword
                        };
                        header = new Headers({ 'Content-Type': 'application/json' });
                        options = new RequestOptions({ headers: header });
                        return [2 /*return*/, new Promise(function (resolve) {
                                _this.http.post(url, req, options).toPromise().then(function (data) {
                                    var res = data.json();
                                    resolve(res.AccessToken);
                                }).catch(function (err) {
                                    if (err.statusText == 'OK') {
                                        resolve(err);
                                    }
                                    else {
                                        _this.util.ShowWaiting(false);
                                        resolve(null);
                                        //this.util.ErrorDialog('System Error : ' + err);
                                    }
                                });
                            })];
                }
            });
        });
    };
    ApiService.prototype.getKey = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var url;
            return __generator(this, function (_a) {
                url = "";
                if (environment.apiPort == "") {
                    //url = environment.apiurl + environment.apiPath
                    url = this.util.baseUrl() + environment.apiPath;
                }
                else {
                    //url = environment.apiurl + ":" +environment.apiPort + environment.apiPath
                    url = this.util.baseUrlNoPort() + ":" + environment.apiPort + environment.apiPath;
                }
                //let url = this.util.baseUrlNoPort() + (environment.apiPort == "" ? "" : ":" + environment.apiPort)
                //url =  "https://dpaapi.msccrm.com:443/customApi/api/" + "Key" + "/" + "GetKey"
                url += "/api/" + "Key" + "/" + "GetKey";
                return [2 /*return*/, new Promise(function (resolve) {
                        _this.http.get(url).toPromise().then(function (data) { return __awaiter(_this, void 0, void 0, function () {
                            var res;
                            return __generator(this, function (_a) {
                                res = data.json();
                                resolve(res);
                                return [2 /*return*/];
                            });
                        }); }).catch(function (err) {
                            _this.util.ShowWaiting(false);
                        });
                    })];
            });
        });
    };
    ApiService.prototype.keyFromCk = function () {
        return __awaiter(this, void 0, void 0, function () {
            var ck, getKeyRes;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        ck = JSON.parse(localStorage.getItem("dpa_portal"));
                        if (!(ck != null && ck.pbk != null && ck.pbk != "")) return [3 /*break*/, 1];
                        return [2 /*return*/, ck.pbk];
                    case 1:
                        if (ck == null) {
                            ck = {};
                        }
                        return [4 /*yield*/, this.getKey()];
                    case 2:
                        getKeyRes = _a.sent();
                        ck.pbk = getKeyRes;
                        localStorage.setItem("dpa_portal", JSON.stringify(ck));
                        return [2 /*return*/, getKeyRes];
                }
            });
        });
    };
    return ApiService;
}());
export { ApiService };



// WEBPACK FOOTER //
// ./src/app/utility/api.service.ts.pre-build-optimizer.js